import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import swal from 'vue-sweetalert2';
import VueCookies from 'vue-cookies';
import { freeSet } from '@coreui/icons';
import 'sweetalert2/dist/sweetalert2.min.css';
import * as Sentry from '@sentry/browser';
import { VuejsDatatableFactory } from '@neuquen8300/vue-js-datatables';
import * as Integrations from '@sentry/integrations';

const api = require('./plugins/api');
const utils = require('./plugins/utils');
/**
 * 
 * Intento de implementación de datatable custom
 * 
 */
 

Vue.prototype.$apiAdress = process.env.VUE_APP_BACKEND
Vue.prototype.$apiTokenName = process.env.VUE_APP_API_TOKEN_NAME

Vue.config.performance = true

// CoreUI
Vue.use(CoreuiVue);

// Vue Cookies
Vue.use(VueCookies);

// Datatables
Vue.use(VuejsDatatableFactory);

// SweetAlert
Vue.use(swal);

// API Endpoints Plugin
Vue.use(api);

// Utils
Vue.use(utils);

// Sentry

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  logLevel: 'warn',
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true,
    })
  ]
});
console.log(Sentry)
new Vue({
  el: '#app',
  router,
  store,  
  icons,
  icons: { ...freeSet },
  template: '<App/>',
  components: {
    App
  },
})
